export default {
    onsiteStatus: 'On Site Status',
    onsiteStatusMessage: 'There is no one site employee today',
    name: 'Name',
    group: 'Group',
    submittedDate: 'Submitted Date',
    status: 'Status',
    period: 'Period'
}
